//登录
export const USER_LOGIN_SUCCESS="USER_LOGIN_SUCCESS"
export const USER_OUT_LOGIN="USER_OUT_LOGIN"
//迷你工作台折叠
export const MiniWorkbenchCollapse_FOLD="MiniWorkbenchCollapse_FOLD"
export const MiniWorkbenchCollapse_EXPAND="MiniWorkbenchCollapse_EXPAND"
//菜单折叠
export const MENU_FOLD="MENU_FOLD"
export const MENU_EXPAND="MENU_EXPAND"